export const POSTHOG_EVENTS = {
  OFFER_VIEWED: 'offer_viewed',
  TOP_OFFERS_SHOWN: 'top_offers_shown',
  OFFER_PURCHASED: 'offer_purchased',
  OFFER_REMOVED_FROM_CART: 'offer_removed_from_cart',
  FREE_OFFERS_NAVIGATION: 'FREE_OFFERS_NAVIGATION',
  RECOMMENDATIONS_CLICKED: 'recommendations_clicked',
  OFFER_DETAIL_OPENED: 'offer_detail_opened',
  OFFER_MANUALLY_ADDED: 'offer_manually_added',
  OFFER_ADDED_TO_PAY_LATER: 'offer_added_to_pay_later',
  PARTNER_CLICKED: 'partner_clicked',
  INSTANT_CHECK_IN_STARTED: 'instant_check_in_started',
  INSTANT_CHECK_IN_FAILED: 'instant_check_in_failed',
  INSTANT_CHECK_IN_COMPLETED: 'instant_check_in_completed',
  INSTANT_CHECK_IN_PARTIAL: 'instant_check_in_partial',
  INSTANT_CHECK_IN_CREATED_WITH_ERRORS: 'instant_check_in_created_with_errors',

  AUTH_EMAIL_CHECKED: 'auth_email_checked',
  AUTH_STARTED: 'auth_started',
  AUTH_SUCCEEDED: 'auth_succeeded',
  AUTH_FAILED: 'auth_failed',
  SIGNUP_CODE_SENT: 'signup_code_sent',
  SIGNUP_CODE_FAILED: 'signup_code_failed',
  PAYMENT_INITIATED: 'payment_initiated',
  PAYMENT_ERROR: 'payment_error',
  PAYMENT_COMPLETED: 'payment_completed',

  VALIDATION_ERROR: 'validation_error',
  HELP_VIEWED: 'help_viewed',

  HOME_NAVIGATION: 'home_navigation',
  HOME_CHAT_INITIATED: 'home_chat_initiated',

  TRAVEL_GUIDE_OFFER_ADDED: 'travel_guide_offer_added',
  TRAVEL_GUIDE_SLOT_DISMISSED: 'travel_guide_slot_dismissed',
  TRAVEL_GUIDE_BANNER_CLICKED: 'travel_guide_banner_clicked',
  TRAVEL_GUIDE_MAPS_CLICKED: 'travel_guide_maps_clicked',
  TRAVEL_GUIDE_MAPS_LINK_CLICKED: 'travel_guide_maps_link_clicked',
  TRAVEL_GUIDE_DAY_EXPORTED: 'travel_guide_day_exported',
  TRAVEL_GUIDE_DAY_SHARED: 'travel_guide_day_shared',
  TRAVEL_GUIDE_TRIP_SHARED: 'travel_guide_trip_shared',

  REGISTRATION_LINK_COPIED: 'registration_link_copied',
  REGISTRATION_LINK_SHARE_OPENED: 'registration_link_share_opened',

  GUEST_FORM_VIEWED: 'guest_form_viewed',
  GUEST_FORM_AUTOFILL: 'guest_form_autofill',
  GUEST_FORM_SUBMITTED: 'guest_form_submitted',
  GUEST_FORM_SUCCESS: 'guest_form_success',
  GUEST_FORM_ERROR: 'guest_form_error',
  GUEST_FORM_VALIDATION_REJECTED: 'guest_form_validation_rejected',
  GUEST_FORM_INCOMPLETE_MODAL: 'guest_form_incomplete_modal',
  GUEST_FORM_ABANDONED: 'guest_form_abandoned',

  LUGGAGE_OFFER_VIEWED: 'luggage_offer_viewed',
  LUGGAGE_DATETIME_SELECTED: 'luggage_datetime_selected',
  LUGGAGE_STORAGES_RETURNED: 'luggage_storages_returned',
  LUGGAGE_NO_STORAGES: 'luggage_no_storages',
  LUGGAGE_STORAGES_SEARCH_FAILED: 'luggage_storages_search_failed',
  LUGGAGE_STORAGE_DETAILS_OPENED: 'luggage_storage_details_opened',
  LUGGAGE_STORAGE_SELECTED: 'luggage_storage_selected',
  LUGGAGE_BOOKING_INITIATED: 'luggage_booking_initiated',
  LUGGAGE_BOOKING_COMPLETED: 'luggage_booking_completed',
  LUGGAGE_BOOKING_FAILED: 'luggage_booking_failed',
} as const;
